import { parseFunction, replaceDynamicParameter } from './functionParser';
import { DYNAMIC_PARAMETER_TYPE } from './functionParser/constant';
import { getRenderComponentById } from '../store/common/action';
import { recursionCustomParams } from './common';

export const HOOK_FUN_KEY = {
  hook: 'hook',
  beforeLoad: 'beforeLoad',
  connected: 'connectedCallback',
  willLoad: 'componentWillLoad',
  didLoad: 'componentDidLoad',
  willRender: 'componentWillRender',
  didRender: 'componentDidRender',
  willUpdate: 'componentWillUpdate',
  didUpdate: 'componentDidUpdate',
  disconnected: 'disconnectedCallback',
};


/**
 * 通过值查找对应的键
 * @param value 要查找的值
 * @returns 对应的键，如果未找到则返回 null
 */
export function getKeyByValue(value: string): keyof typeof HOOK_FUN_KEY | null {
  return Object.keys(HOOK_FUN_KEY).find(
    (key) => HOOK_FUN_KEY[key as keyof typeof HOOK_FUN_KEY] === value
  ) as keyof typeof HOOK_FUN_KEY || null;
}

/**
 * 钩子函数
 */
export const hookFun = async (bodyFun, prop, instanceId?) => {
  const componentItem = getRenderComponentById(instanceId, prop);
  if (bodyFun?.triggerSetting && componentItem) {
    //解析可视化逻辑
    if (_size(_get(bodyFun, 'triggerSetting.functionBody')) > 0) {
      let triggerSetting = bodyFun.triggerSetting;
      const customParamMap = recursionCustomParams(triggerSetting.functionBody,{})
      const customParamsList = Object.values(customParamMap)
      //当前触发组件prop值替换成真实的触发组件prop
      replaceDynamicParameter(customParamsList, DYNAMIC_PARAMETER_TYPE.CURRENT_PROP, prop);
      replaceDynamicParameter(customParamsList, DYNAMIC_PARAMETER_TYPE.CURRENT_COMPONENT, componentItem);
      await parseFunction(triggerSetting.functionBody, customParamsList, [], instanceId)

    }
  }
};


export const triggerBeforeLoad = async (components, instanceId) => {
  const beforeLoadTasks = components
    .filter(component => _size(_get(component, ["hook", HOOK_FUN_KEY.beforeLoad, "triggerSetting", "functionBody"])) > 0)
    .map(component => hookFun(component.hook[HOOK_FUN_KEY.beforeLoad], component.prop, instanceId));
  await Promise.all(beforeLoadTasks);
}
